import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting, APV, BokkzSbLogic, Effecten, EffectenSoortEffecten,
  GiftTaxEntity,
  NotarieleAkte, OmschrijvingEnBedrag, OndernemingSB, OnroerendeZaakSB, PU, RoerendeZaak,
  Schenking, SchenkingOpPapier, SchenkingRelatieBegiftigdeMetSchenker, Vrijstellingen, Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-effecten',
  standalone: true,
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  templateUrl: './effecten.component.html',
  styleUrl: './effecten.component.css'
})
export class EffectenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public schenkingFg = {} as FormGroup;
  public effectenFg = {} as FormGroup;
  public focusedElementId: string | null = null;

  public optionsEffecten: SelectFormControlItem<string>[] = [
    {value: "AANDELEN_BEURS_GENOTEERD", label: "Beursgenoteerde aandelen"},
    {value: "AANDELEN_NIET_BEURSGENOTEERD", label: "Niet genoteerde aandelen"},
    {value: "OBLIGATIES", label: "Obligaties"},
    {value: "OVERIG", label: "Overige effecten"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    public sbService: BokkzSbLogic,
    private fb: FormBuilder) {
    this.schenkingFg = this.fb.group<Schenking>({
      datumSchenking: null as unknown as Date,
      relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
      herroepelijkeSchenking: null as unknown as boolean,
      schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
      uitbreidingBegripSchenker: null as unknown as boolean,
      contanten: null as unknown as OmschrijvingEnBedrag,
      effecten: null as unknown as Effecten,
      onroerendeZaken: null as unknown as OnroerendeZaakSB,
      ondernemingen: null as unknown as OndernemingSB,
      apv: null as unknown as APV,
      periodiekeUitkering: null as unknown as PU,
      roerendeZaak: null as unknown as RoerendeZaak,
      schuldigerkenning: null as unknown as SchenkingOpPapier,
      kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
      vruchtgebruik: null as unknown as Vruchtgebruik,
      overige: null as unknown as OmschrijvingEnBedrag,
      vrijstellingen: null as unknown as Vrijstellingen,
      notarieleAkte: null as unknown as NotarieleAkte,
      belastingBetaaldInAnderLand: null as unknown as number,
      landCodeBetaaldInAnderLand: null as unknown as string,
    })
    this.effectenFg = this.fb.group<Effecten>({
      omschrijving: null as unknown as string,
      bedrag: null as unknown as number,
      soortEffecten: null as unknown as EffectenSoortEffecten,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
      if (value.aangifte!.schenking) {
        this.schenkingFg.patchValue(value.aangifte!.schenking[0], {emitEvent: false})
        if (value.aangifte!.schenking[0] && value.aangifte!.schenking[0].effecten) {
          this.effectenFg.patchValue(value.aangifte!.schenking[0].effecten, {emitEvent: false})
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.effectenFg.updateValueAndValidity();
    this.schenkingFg.updateValueAndValidity();
    const schenking = this.schenkingFg.value;
    schenking.effecten = {
        omschrijving: this.effectenFg.value.omschrijving,
        bedrag: this.effectenFg.value.bedrag,
        soortEffecten: this.effectenFg.value.soortEffecten
    }
    this.giftTaxEntity.aangifte = {
      ...this.sbAangifte,
      schenking: [schenking],
    } as AangifteSchenkbelasting;
    this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    setTimeout(()=> {
      this.sbService.getCalculation();
    }, 1500)
  }
}
